import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const themes = {
    umfLight: {
        primary: "#1b3970",
        secondary: "#424242",
        accent: "#bc955c",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
    },
    light: {
        primary: "#1b3970",
        accent: "#bc955c",
    },
    dark: {
        primary: "#1b3970",
        accent: "#bc955c",
    },
};

export default new Vuetify({
  theme: {
    themes: themes,
    options: {
      themeCache: {
        get: (key) => localStorage.getItem(JSON.stringify(key)),
        set: (key, value) => localStorage.setItem(JSON.stringify(key), value),
      },
    },
  },
});